let isLoading = true;
const modal = $("#availability-modal");

$("#availability-modal-toggle").click((_) => {
  modal.toggleClass("visible");
});

$("#availability-modal").click((e) => {
  if (e.target !== modal) return;
  modal.removeClass("visible");
});

$("#close-avail-modal").click((_) => {
  modal.removeClass("visible");
});

const getPickupLocations = async () => {
  let headers = {
    "X-Shopify-Storefront-Access-Token": "67b5fd875930b339672137b905fcdacd",
  };

  let body = `{
    locations (first: 10){
      nodes{
          id
          name
          address{
              address1
              city
              zip
              country
          }
      }
    }
  }
  `;

  let res = await $.ajax({
    type: "POST",
    url: "https://vloerenmarkt-nl.myshopify.com/api/2023-01/graphql.json",
    dataType: "json",
    headers: headers,
    data: body,
    contentType: "application/graphql",
    error: function (data) {
      // Errors
      console.error("Error in Storefront API request");
      console.log(data);
    },
  });

  return res.data.locations.nodes;
};

getPickupLocations().then((data) => {
  isLoading = false;
  let locationsHTML = "";

  data.forEach((location) => {
    if (location.name.includes("verzendlocatie")) return;

    let html = `
    <div class="avail-card">
      <div class="location-title">
        <h5> ${location.name} <i class="fa-solid fa-check"></i></h5>
      </div>
      <div class="location-details">
        <p>${location.address.address1}</p>
        <p>${location.address.zip} ${location.address.city}</p>
      </div>        
    </div>
    `;

    locationsHTML += html;
  });

  let container = $(modal).find(".avail-locations")[0];
  $(container).html(locationsHTML);
});
